import axios, { AxiosError } from "axios";
import type { AxiosInstance } from "axios";
import { appConfigs } from "../config";

const request: AxiosInstance = axios.create({
  timeout: 5000,
  baseURL: appConfigs.api || "https://apiv2.wxstores.cn",
});

request.interceptors.request.use(
  (config) => {
    const token = window.localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `bearer ${token}`;
    }
    return config;
  },
  (error: AxiosError) => {
    console.log(error);
    return Promise.reject();
  }
);

request.interceptors.response.use(
  (response) => {
    return response;
  },
  (error: AxiosError) => {
    console.log(error);
    return Promise.reject();
  }
);

export default request;
